import { render, staticRenderFns } from "./batteryAgentDetail.vue?vue&type=template&id=055d0353&scoped=true&"
import script from "./batteryAgentDetail.vue?vue&type=script&lang=js&"
export * from "./batteryAgentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055d0353",
  null
  
)

export default component.exports